import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { scrollToTarget, setLenis } from "@/lib/scroll";

export const SmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.25, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) });
    setLenis(lenis);
    let id;
    const raf = (time) => {
      lenis.raf(time);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      setLenis(null);
    };
  }, []);
  return null;
};

export const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      scrollToTarget("#top", true);
      return undefined;
    }
    const t = setTimeout(() => scrollToTarget(hash), 150);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
};
